if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form?.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.errorPrefix = 'Error adding to cart: ';

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        window.cpap.loadDeferredMedia('.cpap__flyout-add-to-cart__container');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }

            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              window.cpap.logError(this.errorPrefix + response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Commented out from native Dawn as we will display our own cart flyout
              // window.location = window.routes.cart_url;
              // return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderCart(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.renderCart(response);
            }
          })
          .catch((error) => {
            window.cpap.logError(error, {
              sentry__additionalData: {
                'Attempted Action': 'Adding item to cart',
              },
              ga__errorMessagePrefix: this.errorPrefix,
            });
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      renderCart(response) {
        if (this.cart) {
          this.cart.renderContents(response);
        } else {
          this.renderCartDrawer();
        }
      }

      async renderCartDrawer() {
        // Do not render cart drawer if Rebuy's flyout cart override is enabled on site
        if (document.querySelector('.rebuy-cart__flyout')) {
          return;
        }

        window.cpap.createAndDispatchGlobalEvent('cartDrawerUpdating');

        document.body.style.overflow = 'hidden';

        const quantityText = document.querySelector('.qty-title .number-box').textContent;
        document.querySelector('.content-cart-header .content-cart-quantity').textContent =
          quantityText;

        const cartDrawerProductsNode = document.querySelector(
          '#add-to-cart-scrolly .add-to-cart-products'
        );
        cartDrawerProductsNode.innerHTML = '';

        window.cpap.openFlyout('.cpap__flyout-add-to-cart__container');

        let lastItemAddedToCart = localStorage.getItem('last_item_added_to_cart');
        let lastItemAddedToCartSellingPlan = localStorage.getItem(
          'last_item_added_to_cart_selling_plan'
        );

        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();

          let cartItems = cart.items;
          let itemIndex;
          cartItems.every((item, index) => {
            if (item.variant_id == lastItemAddedToCart) {
              if (lastItemAddedToCartSellingPlan != '') {
                if (item.hasOwnProperty('selling_plan_allocation')) {
                  if (
                    item.selling_plan_allocation.selling_plan.id == lastItemAddedToCartSellingPlan
                  ) {
                    itemIndex = index;
                    return false;
                  }
                }
              } else {
                if (item.hasOwnProperty('selling_plan_allocation')) {
                  return true;
                } else {
                  itemIndex = index;
                  return false;
                }
              }
            }
            return true;
          });
          let createDynamicHTML = '';
          createDynamicHTML += '<div class="content-cart-body">';
          createDynamicHTML += '<div class="cart-product-image">';
          if (cart.items[itemIndex].image) {
            createDynamicHTML +=
              '<img src="' + cart.items[itemIndex].image + '" alt="" width="" height="">';
          }
          createDynamicHTML += '</div>';
          createDynamicHTML += '<div class="cart-product-details">';
          createDynamicHTML += '<h5>' + cart.items[itemIndex].product_title + '</h5>';
          for (var key in cart.items[itemIndex].options_with_values) {
            var obj = cart.items[itemIndex].options_with_values[key].value;
            if (obj != 'Default Title') {
              createDynamicHTML += '<ul class="">';
              createDynamicHTML += '<li>' + obj + '</li>';
              createDynamicHTML += '</ul>';
            }
          }
          if (cart.items[itemIndex].selling_plan_allocation) {
            createDynamicHTML +=
              '<ul><li>' +
              cart.items[itemIndex].selling_plan_allocation.selling_plan.name +
              '</li></ul>';
          }
          createDynamicHTML += '<p class="cart-product-price">';
          createDynamicHTML +=
            '<span class="original-price">' +
            this.formatMoney(cart.items[itemIndex].price) +
            '</span>';
          createDynamicHTML += '<span class="compare-price d-none"></span>';
          createDynamicHTML += '</p>';
          createDynamicHTML += '</div>';
          createDynamicHTML += '</div>';
          cartDrawerProductsNode.innerHTML = createDynamicHTML;

          window.cpap.createAndDispatchGlobalEvent('cartDrawerUpdate');
        } catch (error) {
          window.cpap.logError(error, {
            sentry__additionalData: {
              'Attempted Action': 'Fetch shopping cart',
            },
            ga__errorMessagePrefix: 'Error fetching cart: ',
          });
        }
      }

      formatMoney(amount) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
          amount / 100
        );
      }
    }
  );
}
